import { getClipParams } from '../../utils/animationsUtils';
import type { AnimationProperties, AnimationsKit } from '../../types';
import { toArray } from '@wix/wow-utils';

const name = 'BaseClipPath';
const properties: Partial<AnimationProperties> = {};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration: number = 0,
  delay: number = 0,
  { to = {}, from = {}, useClipRect = false, ...params }: any = {},
) {
  const sequence = kit.sequence();
  elements = toArray(elements) as HTMLElement[];

  elements.forEach((element) => {
    const compRect = kit.engine.getBoundingRect(element);
    const contentRect = kit.engine.getBoundingContentRect(element);
    const initialClipPath = getClipParams(compRect, contentRect, 'initial', {
      useClipRect,
    });

    sequence.add(
      kit.engine.tween(
        element,
        {
          duration,
          delay,
          to: {
            ...initialClipPath,
            ...to,
          },
          from: {
            ...initialClipPath,
            ...from,
          },
          ...params,
        },
        ['clipPath', 'webkitClipPath', 'clip'],
      ),
      0,
    );
  });

  return sequence.get();
}

export { name, properties, animate };
